import { Component, Input } from '@angular/core';
import { StatusService, ConnectionStatus } from '../../../services/status.service';

@Component({
    selector: 'app-connection-header',
    templateUrl: './connection-header.component.html',
    styleUrls: ['./connection-header.component.css']
})
export class ConnectionHeaderComponent {
    @Input() status: ConnectionStatus = 'connected';

    constructor(private statusService: StatusService) { }

    toggleStatus(): void {
        this.statusService.toggleStatus();
    }
} 